import * as arrearsTransactionTableColumns from '../actions/arrears-transaction-table-columns.action'
import { IColumnDefinition } from '@common/models/column-definition';

export interface State{
  allColumns: IColumnDefinition[],
  loading: boolean,
}

export const INITIAL_STATE: State = {
  allColumns: undefined,
  loading: false,
}


export function reducer(state: State = INITIAL_STATE, action: arrearsTransactionTableColumns.Actions): State {
  switch (action.type) {
  case arrearsTransactionTableColumns.LOAD_ALL:
      {
        return {
          ...state,
          loading: true
        };
      }
    case arrearsTransactionTableColumns.LOAD_ALL_COMPLETE:
      {
        return {
          ...state,
          allColumns: action.payload,
          loading: false
        };
      }
    default:
    {
      return state;
    }
  }

}

